module.exports = __webpack_public_path__ + "components/MapControl/svg/Policja.svg?80f5b23d";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Policja.svg
// module id = 1974
// module chunks = 0